// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';
import Stripe                   from 'stripe';

const stripeGetPaymentMethod = async ({
    test,
    paymentIntentId,
}: {
    test: boolean,
    paymentIntentId: string,
}): Promise<Stripe.PaymentMethod | null> => {
    const functions = getFunctions();
    const getPaymentMethod = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        Stripe.PaymentMethod | null
    >(
        functions,
        'stripeGetPaymentMethod',
    );
    return getPaymentMethod({
        test,
        paymentIntentId,
    }).then((result) => {
        const paymentMethod = result.data as Stripe.PaymentMethod | null;
        return paymentMethod;
    }).catch((err) => {
        throw err;
    });
};

export default stripeGetPaymentMethod;
